import objectGroupBy from "src/functions/objectGroupBy";
import objectSort from "src/functions/objectSort";
import { ApiDiscountNested } from "src/types/ApiDiscountNested";

const getSortedDiscounts = (
  data: ApiDiscountNested[],
  best?: boolean,
  grouped?: boolean
) => {
  const discounts = data && objectSort(objectGroupBy(data, ["group", "value"]));
  const reverseKeys = Object.keys(discounts).reverse();
  const filterHighest = best
    ? [
        reverseKeys.filter((element) => element.includes("all"))[0] || "all:0",
        reverseKeys.filter((element) => element.includes("user"))[0] ||
          "user:0",
        reverseKeys.filter((element) => element.includes("instructor"))[0] ||
          "instructor:0",
      ]
    : reverseKeys;
  let result = [];
  for (let i = 0; i < filterHighest.length; i++) {
    discounts[filterHighest[i]] && result.push(...discounts[filterHighest[i]]);
  }
  result = grouped ? objectGroupBy(result, ["group"]) : result;
  return result;
};

export default getSortedDiscounts;
